import { render, staticRenderFns } from "./dashboard-collapse-link-list.vue?vue&type=template&id=2085d75e&scoped=true&"
import script from "./dashboard-collapse-link-list.vue?vue&type=script&lang=js&"
export * from "./dashboard-collapse-link-list.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-collapse-link-list.vue?vue&type=style&index=0&id=2085d75e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085d75e",
  null
  
)

export default component.exports